import React from "react";
import { getPdf7005RecordData } from "./../../../actions/contracts";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import BootstrapTable from "react-bootstrap-table-next";
import "react-select/dist/react-select.css";
import { NavLink } from "react-router-dom";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, {
  textFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import classnames from "classnames";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import Responsive from "react-responsive";
import { Loader } from "../../../components/loader";
import Select from "react-select";

const $ = window.$;
const { SearchBar } = Search;
var _self;
const orientation = window.matchMedia("(max-width: 700px)").matches
  ? "vertical"
  : "horizontal";

class CenteredTabs extends React.Component {
  constructor(props) {
    super(props);
    _self = this;
  }
  state = {
    selectedTab: "",
    avatar_file_name: "",
    avatar_path: "",
    monthSelectionOption: [],
    monthlyContractData: [],
  };

  tableHeaderColumnData = [
    {
      dataField: "date",
      text: "Transition date",
      sort: true,
    },
    {
      dataField: "cus_firstname",
      text: "Buyer name",
      sort: true,
      formatter: (cell, row) => {
        return <p>{row.cusFirstname + " " + row.cusLastname}</p>;
      },
    },
    {
      dataField: "shipper_name",
      text: "Delivery company",
      sort: true,
    },
    {
      dataField: "breedType",
      text: "Breed",
      sort: true,
    },
    {
      dataField: "petId",
      text: "Puppy ID",
      sort: true,
    },
    {
      dataField: "sex",
      text: "View APH 7006",
      formatter: (cell, row) => {
        return (
          <a
            href={`${process.env.REACT_APP_API_ENDPOINT}/core/contract/doc/pdf/generate7006/${this.props.data.petShopReducer.currentPetshop.id}/${row.id}`}
            className="dropdown-item"
            target="_blank"
          >
            <i className="far fa-eye"></i>
          </a>
        );
      },
    },
  ];

  loadMonths = (selectedYear) => {
    let monthArray = [];
    const thisMonth = moment().format("M");
    const thisMonthFormat1 = moment().format("MM");
    const thisMonthFormat4 = moment().format("MMMM");
    const thisYearFormat3 = moment().format("YYYY");
    const thisMonthStartDate = `${thisYearFormat3}-${thisMonthFormat1}-01`;
    const petShopId = this.props.data.petShopReducer.currentPetshop.id;
    const isSameYear = selectedYear == thisYearFormat3 ? true : false;
    const selectedDate = `${selectedYear}-12-01`;
    // Add previous months data
    if (isSameYear) {
      for (let i = 0; i < thisMonth; i++) {
        let monthFormat1 = moment().subtract(i, "months").format("MM");
        let monthFormat3 = moment().subtract(i, "months").format("YYYY");
        let monthFormat4 = moment().subtract(i, "months").format("MMMM");
        monthArray.push({
          label: `${monthFormat4}`,
          value: `${monthFormat4}`,
          startDate: `${monthFormat3}-${monthFormat1}-01`,
        });
      }
      this.setState({ selectedTab: thisMonthStartDate });
      this.props.getPdf7005RecordData(petShopId, thisMonthStartDate);
    } else {
      for (let i = 0; i < 12; i++) {
        let monthFormat1 = moment(selectedDate)
          .subtract(i, "months")
          .format("MM");
        let monthFormat3 = moment(selectedDate)
          .subtract(i, "months")
          .format("YYYY");
        let monthFormat4 = moment(selectedDate)
          .subtract(i, "months")
          .format("MMMM");
        monthArray.push({
          label: `${monthFormat4}`,
          value: `${monthFormat4}`,
          startDate: `${monthFormat3}-${monthFormat1}-01`,
        });
      }
      this.setState({ selectedTab: selectedDate });
      this.props.getPdf7005RecordData(petShopId, selectedDate);
    }
    this.setState({ monthSelectionOption: monthArray });
  };

  loadYearInfo = () => {
    let yearArray = [];
    const currentYear = moment().format("YYYY");
    const processStartYear = 2024;
    const eligibleNoOfYears = currentYear - processStartYear;
    for (let i = 0; i <= eligibleNoOfYears; i++) {
      let yearFormat = moment().subtract(i, "years").format("YYYY");
      if (processStartYear <= yearFormat) {
        yearArray.push({
          label: `${yearFormat}`,
          value: `${yearFormat}`,
        });
      }
    }
    this.setState({
      timeYearlyOptions: yearArray,
      selectedTimeDurationYear: currentYear,
      monthlyDataLoading: true,
    });
    this.loadMonths(currentYear);
  };

  changeYearOption = (timeOption) => {
    if (timeOption && timeOption.value) {
      this.loadMonths(timeOption.value);
      this.setState({ selectedTimeDurationYear: timeOption.value });
    }
  };

  loadContracts = (month) => {
    const petShopId = this.props.data.petShopReducer.currentPetshop.id;
    if (month && petShopId) {
      this.setState({ selectedTab: month, loadingContracts: true });
      this.props.getPdf7005RecordData(petShopId, month);
    }
  };

  buttonFormatter(cell, row) {
    return (
      <div>
        <button
          className="m-portlet__nav-link btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
          title="View"
        >
          <a href="" target="_blank">
            <i className="far fa-eye"></i>
          </a>
        </button>
      </div>
    );
  }

  async getPdf7005ContractData(e) {
    e.preventDefault();
    let contractData = this.state.monthlyContractData;
    if (contractData && contractData.length > 0) {
      let pdf7005Button = document.getElementById("pdf_7005_button");
      setTimeout(() => {
        if (pdf7005Button) {
          pdf7005Button.click();
        }
      }, 200);
    } else {
      NotificationManager.error("Contracts data not found.");
    }
  }

  componentDidMount() {
    this.loadYearInfo();
  }

  componentWillReceiveProps = (nextProps) => {
    if (
      nextProps.data.contractsReducer.monthlyContracts !==
      this.props.data.contractsReducer.monthlyContracts
    ) {
      this.setState({
        monthlyContractData: nextProps.data.contractsReducer.monthlyContracts,
        loadingContracts: false,
      });
    }

    if (
      nextProps.data.contractsReducer.monthlyContractsError !==
      this.props.data.contractsReducer.monthlyContractsError
    ) {
      this.setState({ loadingContracts: false });
      NotificationManager.error(
        "An error occurred while loading the contracts",
      );
    }
  };

  items = [{ title: "Puppy Records" }];

  render() {
    const { classes, theme } = this.props;
    const {
      monthSelectionOption,
      monthlyContractData,
      loadingContracts,
      timeYearlyOptions,
      selectedTimeDurationYear,
    } = this.state;

    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__head medical-record-head-btn-set">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">APH 7005 / 7006</h3>
                    </div>
                  </div>
                  <div className="m-portlet__head-tools">
                    <ul className="m-portlet__nav">
                      <li className="m-portlet__nav-item">
                        <div
                          style={{
                            width: "150px",
                            margin: "0 auto",
                            marginTop: "15px",
                          }}
                        >
                          <Select
                            options={timeYearlyOptions}
                            value={selectedTimeDurationYear}
                            name="selectedTimeDurationYear"
                            onChange={this.changeYearOption}
                            placeholder="Select The Time"
                          />
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="m-portlet__body medical-record-content">
                  <ul
                    className="nav nav-pills nav-pills--success m-nav-pills--btn-pill m-nav-pills--btn"
                    role="tablist"
                  >
                    {monthSelectionOption.map((item) => (
                      <li className="nav-item m-tabs__item">
                        <a
                          className={classnames({
                            "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                            active: this.state.selectedTab === item.startDate,
                          })}
                          onClick={() => this.loadContracts(item.startDate)}
                        >
                          {item.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                  <div className="m-form m-form--label-align-right m--margin-top-20 m--margin-bottom-30">
                    <div className="row align-items-center">
                      <div className="col-xl-6 order-2 order-xl-1"></div>
                      <div className="col-xl-6 order-1 order-xl-2 m--align-right">
                        <button
                          type="button"
                          className="btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill mr-2"
                          onClick={(e) => this.getPdf7005ContractData(e)}
                        >
                          View APH 7005
                        </button>
                        <a
                          href={`${process.env.REACT_APP_API_ENDPOINT}/core/contract/doc/pdf/generate7005/${this.props.data.petShopReducer.currentPetshop.id}/${this.state.selectedTab}`}
                          className="btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill mr-2"
                          id="pdf_7005_button"
                          target="_blank"
                          style={{ display: "none" }}
                        >
                          <span>
                            <i className="la la-print pr-2"></i>
                            <span>Pdf 7005</span>
                          </span>
                        </a>
                        <div className="m-separator m-separator--dashed d-xl-none"></div>
                      </div>
                    </div>
                  </div>
                  <div className="tab-content">
                    {!loadingContracts ? (
                      <ToolkitProvider
                        keyField="id"
                        data={monthlyContractData}
                        columns={this.tableHeaderColumnData}
                        search
                        hover={true}
                        filter={filterFactory()}
                      >
                        {(props) => (
                          <div>
                            <div className="px-0 mb-4 search-bar">
                              <div className="col-lg-3 px-0 inner-addon right-addon">
                                <i className="fas fa-search"></i>
                                <SearchBar {...props.searchProps} />
                              </div>
                            </div>
                            <div className="mb-2"></div>
                            <BootstrapTable
                              classes="petTable"
                              {...props.baseProps}
                              pagination={paginationFactory()}
                            />
                          </div>
                        )}
                      </ToolkitProvider>
                    ) : (
                      <div className="center-row">
                        <Loader size={50} />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export const Mobile = (props) => <Responsive {...props} maxWidth={767} />;
export const Default = (props) => <Responsive {...props} minWidth={768} />;

const mapStateToProps = (state) => ({
  data: state,
});

const mapDispatchToProps = (dispatch) => ({
  getPdf7005RecordData: (petshopId, sdate) => {
    dispatch(getPdf7005RecordData(petshopId, sdate));
  },
});

CenteredTabs = connect(mapStateToProps, mapDispatchToProps)(CenteredTabs);

export default withRouter(CenteredTabs);
